module.exports = __webpack_public_path__ + "img/Card_Punch_Yellow-min.1e78ca88.png";